import {createLogic} from 'redux-logic';
import {
  authRefreshSession,
} from '../actions';

import gql from 'graphql-tag';
import {applicationClient as client} from 'App/index';
import {timerRefreshRequest} from 'App/util/redux/autoLogout/actions';
import {
  authLoginError,
  authLoginSuccess,
} from 'App/util/redux/auth/actions';

export const authRefreshSessionLogic = createLogic({
  type: authRefreshSession,
  cancelType: [
    authLoginError,
    authLoginSuccess
  ],
  latest: true, // take latest only

  processOptions: {
    dispatchReturn: false
  },

  process({action}, dispatch, done) {
    performRefresh().then(
      data => dispatch(timerRefreshRequest())
    ).catch(e => console.log('error: '+e));

    done();
  }
});

const performRefresh = () => {
  return client
    .query({
      query: gql`
          {
            refresh_token
          }`,
      fetchPolicy: 'network-only'
    });
};


// WEBPACK FOOTER //
// ./src/util/redux/auth/logic/refresh.js